module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    ref: "d_modal",
    staticClass: "modal__confirm__delete-wrapper text-dark",
    class: [{
      'js-no-close': _vm.appendToBody
    }, {
      'modal__confirm__delete__wider': _vm.isShowDontAskAgain
    }],
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "modal__confirm__delete"
  }, [(_vm.showClose) ? _c('div', {
    staticClass: "close-cross icon__bg-circle",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })]) : _vm._e(), _vm._v(" "), _vm._t("insertComponent", function() {
    return [_c('div', {
      staticClass: "modal__confirm__delete__template",
      attrs: {
        "slot": "insertComponent"
      },
      slot: "insertComponent"
    }, [_c('div', [_c('div', {
      staticClass: "modal__confirm__delete__close icon__bg-circle",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.$emit('close')
        }
      }
    }, [_c('span', {
      staticClass: "icon-cross2"
    })]), _vm._v(" "), _vm._t("item"), _vm._v(" "), (_vm.isShowConfirmDeleteMessage) ? [(!_vm.isOnlyOwnCalendarText) ? _c('h4', [_vm._v(_vm._s(_vm.i18n.are_you_sure))]) : _vm._e(), _vm._v(" "), (_vm.isOnlyOwnCalendarText) ? _c('h4', [_vm._v(_vm._s(_vm.i18n.are_you_sure_own_calendar))]) : _vm._e()] : _vm._e(), _vm._v(" "), _c('div', [_vm._t("custom_warning")], 2), _vm._v(" "), _c('div', {
      staticClass: "modal__confirm__delete__buttons"
    }, [(_vm.isShowDontAskAgain) ? _c('div', {
      staticClass: "do-checkbox-group"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.isDontAskAgain),
        expression: "isDontAskAgain"
      }],
      staticClass: "form-check-input",
      attrs: {
        "type": "checkbox",
        "id": "dontAskAgain"
      },
      domProps: {
        "checked": Array.isArray(_vm.isDontAskAgain) ? _vm._i(_vm.isDontAskAgain, null) > -1 : (_vm.isDontAskAgain)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.isDontAskAgain,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.isDontAskAgain = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.isDontAskAgain = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.isDontAskAgain = $$c
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "d-label form-check-label",
      attrs: {
        "for": "dontAskAgain"
      }
    }, [_vm._v(_vm._s(_vm.i18n.dont_ask_me_again))])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "modal__confirm__delete__buttons__buttons"
    }, [_vm._t("confirm_buttons", function() {
      return [_c('button', {
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.$emit('close')
          }
        }
      }, [_vm._v(_vm._s(_vm.i18n.cancel))]), _vm._v(" "), _c('button', {
        ref: "submit_bttn",
        staticClass: "bttn bttn--danger",
        class: {
          'bttn--loading': _vm.isSubmitButtonLoading
        },
        on: {
          "keyup": [function($event) {
            if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
            return _vm.onConfirm.apply(null, arguments)
          }, function($event) {
            if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
            return _vm.$emit('close')
          }],
          "click": function($event) {
            $event.stopPropagation();
            return _vm.onConfirm.apply(null, arguments)
          }
        }
      }, [_vm._t("confirmText", function() {
        return [_vm._v(_vm._s(_vm.i18n.delete))]
      })], 2)]
    })], 2)])], 2)])]
  })], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-90089d60!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modals/ModalConfirmation.vue
// module id = 1721
// module chunks = 1